import React from 'react';
import { Hero } from '../components/Hero';
import { ProblemSolutionSection } from '../components/ProblemSolutionSection';
import { ReadyToTeachSection } from '../components/ReadyToTeachSection';
import { LibrarySection } from '../components/LibrarySection';
import { BonusesSection } from '../components/BonusesSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { OfferSection } from '../components/OfferSection';
import { FaqSection } from '../components/FaqSection';
import { FinalCtaSection } from '../components/FinalCtaSection';
import { Footer } from '../components/Footer';
import { PurchaseNotifications } from '../components/PurchaseNotifications';
export function Landing() {
  return <div className="w-full bg-ivory" data-id="element-200" data-mp="c84car0emdfm">
      <Hero data-id="element-201" data-mp="cb8l61otdxcm" />
      <main data-id="element-202" data-mp="h8qx80y4osou">
        <ProblemSolutionSection data-id="element-203" data-mp="h90mtnf9gxu0" />
        <ReadyToTeachSection data-id="element-204" data-mp="ha21e1vhk2gh" />
        <LibrarySection data-id="element-205" data-mp="h6nwalvftf5c" />
        <BonusesSection data-id="element-206" data-mp="m727gcsc557l" />
        <TestimonialsSection data-id="element-207" data-mp="m8n1806tsk4e" />
        <OfferSection data-id="element-208" data-mp="m7v94zcft4iv" />
        <FaqSection data-id="element-209" data-mp="2a0n4fmvd2bh" />
        <FinalCtaSection data-id="element-210" data-mp="2aju51aze6aq" />
      </main>
      <Footer data-id="element-211" data-mp="2blfbylpo966" />
      <PurchaseNotifications data-id="element-212" data-mp="27xmz2s05st1" />
    </div>;
}